import React from "react";
import { StyleProp, ViewStyle } from "react-native";
import { View } from "native-base";
import { ChevronLeft, ChevronRight } from "lucide-react-native";

import { PressableWrap } from "../../Buttons/PressableColorWrap/PressableColorWrap";

type ExpandedImageArrowsProps = {
  visible: boolean;
  scaleAll: number;
  leftOffset: number;
  rightOffset: number;
  onPrev: () => void;
  onNext: () => void;
  leftWrapperStyle: StyleProp<ViewStyle>;
  rightWrapperStyle: StyleProp<ViewStyle>;
  buttonStyle: StyleProp<ViewStyle>;
};

const ExpandedImageArrows: React.FC<ExpandedImageArrowsProps> = ({
  visible,
  scaleAll,
  leftOffset,
  rightOffset,
  onPrev,
  onNext,
  leftWrapperStyle,
  rightWrapperStyle,
  buttonStyle,
}) => {
  if (!visible) return null;

  return (
    <>
      <View style={[leftWrapperStyle, { left: leftOffset }]} pointerEvents="box-none">
        <PressableWrap onPress={onPrev}>
          <View style={buttonStyle}>
            <ChevronLeft size={28 * scaleAll} color="white" strokeWidth={2} />
          </View>
        </PressableWrap>
      </View>

      <View style={[rightWrapperStyle, { right: rightOffset }]} pointerEvents="box-none">
        <PressableWrap onPress={onNext}>
          <View style={buttonStyle}>
            <ChevronRight size={28 * scaleAll} color="white" strokeWidth={2} />
          </View>
        </PressableWrap>
      </View>
    </>
  );
};

export default React.memo(ExpandedImageArrows);
